export const goToLogin = (navigate) => {
  navigate("/");
};

export const goToSignup = (navigate) => {
  navigate("/signup");
};

export const goToMain = (navigate) => {
  navigate("/main");
};

export const goToCourses = (navigate) => {
  navigate("/courses");
};

export const goToJavascript = (navigate) => {
  navigate("/javascript");
};

export const goToForum = (navigate) => {
  navigate("/forum");
};

export const goToExplore = (navigate) => {
  navigate("/explore");
};

export const goToTutores = (navigate) => {
  navigate("/tutores");
};

export const goToEvents = (navigate) => {
  navigate("/events");
};

export const goToVr = (navigate) => {
  navigate("/vr");
};

export const goToTesla = (navigate) => {
  navigate("/nikolatesla");
};